export default "__VITE_ASSET__UBIj8_I___"